import React from 'react';
import {MatchResponse} from "../domain/match/models";
import './MatchConfirmation.css'

interface Props {
    result: MatchResponse
    onRecordAnother: () => void
    onDismiss: () => void
}

export function MatchConfirmation({result, onRecordAnother, onDismiss}: Props) {
    const winnerDelta = result.WinnerRatingAfter - result.WinnerRatingBefore;
    const loserDelta = result.LoserRatingAfter - result.LoserRatingBefore;

    return (
        <section className="match-confirmation">
            <header className="match-confirmation-header">
                <h3>Match Recorded</h3>
                <button className="unfocus" onClick={onDismiss}>&times;</button>
            </header>
            <div className="match-confirmation-players">
                <div className="match-confirmation-player winner">
                    <div className="match-confirmation-label">Winner</div>
                    <div className="match-confirmation-name">
                        {result.WinnerFirstName} {result.WinnerLastName}
                    </div>
                    <div className="match-confirmation-rating">
                        <span className="match-confirmation-delta positive">+{winnerDelta}</span>
                        <span className="match-confirmation-detail">
                            {result.WinnerRatingBefore} &rarr; {result.WinnerRatingAfter}
                        </span>
                    </div>
                </div>
                <div className="match-confirmation-player loser">
                    <div className="match-confirmation-label">Loser</div>
                    <div className="match-confirmation-name">
                        {result.LoserFirstName} {result.LoserLastName}
                    </div>
                    <div className="match-confirmation-rating">
                        <span className="match-confirmation-delta negative">{loserDelta}</span>
                        <span className="match-confirmation-detail">
                            {result.LoserRatingBefore} &rarr; {result.LoserRatingAfter}
                        </span>
                    </div>
                </div>
            </div>
            <button className="match-confirmation-record-another" onClick={onRecordAnother}>
                Record Another
            </button>
        </section>
    );
}
